//import jQuery from 'jquery'
import { gsap } from 'gsap';

//import { ScrollTrigger } from 'gsap/ScrollTrigger';
//import { SplitText } from 'gsap/SplitText';
//import { GSDevTools } from 'gsap/GSDevTools';

class CustomAnimation {
  init() {
  }

  animateHeaderImage(element){
    gsap.to(element, {
      scrollTrigger: {
        trigger: '.header',
        start: 'top 0%',
        end: 'bottom 0%',
        markers: false,
        scrub: 0
      },
      scale:1,
      y: 200
    });
  }

  animateBgImage(element, trigger){
    gsap.from(element, {
      scrollTrigger: {
        trigger: trigger,
        start: 'top 110%',
        end: 'top 20%',
        markers: false,
        scrub: 0
      },
      y: 200
    });
  }

  scaleBgImage(element, trigger){
    gsap.from(element, {
      scrollTrigger: {
        trigger: trigger,
        start: 'top 110%',
        end: 'top 20%',
        markers: false,
        scrub: 0
      },
      scale: 1.2
    });
  }

  animateTextAlpha(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 100%',
        end: 'top 50%',
        markers: false,
        scrub: 0
      },
      y: 20,
      scale: 1,
      opacity: 0
    });
  }

  animateTextVertical(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 110%',
        end: 'top 50%',
        markers: false,
        scrub: 0
      },
      y: 100,
      scale: 1,
      opacity: 0
    });
  }

  animateImageGroup(elements) {
    const elementGroup = gsap.utils.toArray(elements);
    elementGroup.forEach((element) => {
      gsap.from(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 110%',
          end: 'top 65%',
          markers: false,
          scrub: 0
        },
        y: 50,
        opacity: 0,
        scale: .9
      });
    });
  }

  animateHeadlineGroup(elements) {
    const elementGroup = gsap.utils.toArray(elements);
    elementGroup.forEach((element) => {
      gsap.from(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 100%',
          end: 'top 50%',
          markers: false,
          scrub: 0
        },
        y: 20,
        scale: 1,
        opacity: 0
      });
    });
  }

  animateTextGroup(elements) {
    const elementGroup = gsap.utils.toArray(elements);
    elementGroup.forEach((element) => {
      gsap.from(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 110%',
          end: 'top 65%',
          markers: false,
          scrub: 0
        },
        y: 100,
        scale: 1,
        opacity: 0
      });
    });
  }




  animateIntro() {
    gsap.from('.intro_container', {
      scrollTrigger: {
        trigger: '.intro',
        start: 'center 110%',
        end: 'bottom 70%',
        markers: false,
        scrub: 0
      },
      y: -50,
      scale: .9
    });
  }

  animateElement(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 110%',
        end: 'top 65%',
        markers: false,
        scrub: 0
      },
      y: 50
    });
  }

  animateContactDetail(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 110%',
        end: 'top 65%',
        markers: false,
        scrub: 0
      },
      y: 150
    });
  }

  animateScale(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 110%',
        end: 'top 65%',
        markers: false,
        scrub: 0
      },
      scale: .9
    });
  }

  animateScaleDown(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 110%',
        end: 'top 30%',
        markers: false,
        scrub: 0
      },
      scale: 1.2,
      y: 50
    });
  }

  animateImage(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 110%',
        end: 'top 65%',
        markers: false,
        scrub: 0
      },
      y: 150
    });
  }

  animateBackgroundImage(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 90%',
        end: 'bottom 10%',
        markers: false,
        scrub: 0
      },
      y: 50
    });
  }

  animateFromLeft(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 110%',
        end: 'top 65%',
        markers: false,
        scrub: 0
      },
      x: -60
    });
  }

  animateFromRight(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 110%',
        end: 'top 65%',
        markers: false,
        scrub: 0
      },
      x: 60
    });
  }

  animateButtonHolder(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 110%',
        end: 'top 65%',
        markers: false,
        scrub: 0
      },
      x: 30
    });
  }

  animateFooter(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top 110%',
        end: 'top 85%',
        markers: false,
        scrub: 0
      },
      y: 100,
      scale: .9
    });
  }


  animateDemotext(element) {
    gsap.to(element, {
      scrollTrigger: {
        trigger: element,
        start: 'center 50%',
        end: 'bottom 30%',
        markers: false,
        scrub: 0
      },
      y: 200
    });
  }

  animateDemoForm(element) {
    gsap.from(element, {
      scrollTrigger: {
        trigger: element,
        start: 'center 50%',
        end: 'bottom 30%',
        markers: false,
        scrub: 0
      },
      y: 0
    });
  }
}

export default CustomAnimation;
